import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import CloudIcon from "@material-ui/icons/Cloud";
import CloudOff from "@material-ui/icons/CloudOff";

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        margin: 'auto',
        height: `calc(100% - ${theme.spacing(4)}px)`,
    },
}));

function PipeStatus({status}) {
    if (status === undefined) return null;

    return status === "ACTIVE"
        ? (
            <Typography align={"right"}>
                <Tooltip title="Active">
                    <CloudIcon color="action"/>
                </Tooltip>
            </Typography>
        )
        : (
            <Typography align={"right"}>
                <Tooltip title="Inactive">
                    <CloudOff color="disabled"/>
                </Tooltip>
            </Typography>
        );
}

export default function PipeCard({title, status, content, bottom, direction = "column"}) {
    const classes = useStyles();

    return (
        <Paper className={classes.paper}>
            <Grid container spacing={2} direction={direction} justify={"space-between"} alignItems={"center"}>
                <Grid item xs={12} container>
                    <Grid item xs={2}/>
                    <Grid item xs={8}>
                        <Typography align={"center"} noWrap>{title}</Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <PipeStatus status={undefined}/>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    {content}
                </Grid>
                {
                    bottom ? (
                        <Grid item xs={12}>
                            {bottom}
                        </Grid>
                    ) : null
                }
            </Grid>
        </Paper>
    );
}